import dvaModelExtend from 'dva-model-extend';

import { bindServices } from '@/services/api';
import { createCrudModel } from '@/utils/core/dva';

import { ENTITY_NAME, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);

const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute: FETCH_ROUTE,
  fetchParams: 'Sequence',
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: true },
  state: {
    showSubSequencesDrawer: false,
    showTracesDrawer: false,
    drawerSequenceItem: null,
  },
  effects: {
    *showSubSequencesDrawer({ payload }, { put }) {
      yield put({
        type: 'querySubSequencesDrawer',
        payload: { open: payload.open, item: payload.item },
      });
    },
    *showTracesDrawer({ payload }, { put }) {
      yield put({
        type: 'queryTracesDrawer',
        payload: { open: payload.open, item: payload.item },
      });
    },
  },
  reducers: {
    querySubSequencesDrawer(state, { payload }) {
      return {
        ...state,
        showSubSequencesDrawer: payload.open,
        drawerSequenceItem: payload.item ?? null,
      };
    },
    queryTracesDrawer(state, { payload }) {
      return {
        ...state,
        showTracesDrawer: payload.open,
        drawerSequenceItem: payload.item ?? null,
      };
    },
  },
});

export default dvaModelExtend(_model, { namespace: MODEL_NAME });
